import * as React from 'react';
import Themeable from '../../types/Themeable';
import ReviewModel from '../../types/ReviewModel';
import ReviewerDisplayContainer from '../ReviewerDisplay/ReviewerDisplayContainer';
import Strings from '../../globals/Strings';
import {ModalStates} from '../../globals/Constants';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import ReviewVersionModel from '../../types/ReviewVersionModel';

const MAX_NUMBER_OF_AVATARS_TO_DISPLAY = 4;

export default ({review, reviewVersion, themeName, isOwner, setModalState}: ReviewersDetailElementProps) => {
   const reviewers = review.Reviewers.filter(reviewer => !reviewer.WasUserRoleRemoved);
   const leftElement = (reviewers.length > 1) ?
      <div className="left-element review-members"><ReviewerDisplayContainer review={review} numberAvatarsDisplayed={MAX_NUMBER_OF_AVATARS_TO_DISPLAY}/></div>
      : <div className="left-element section-value empty">{Strings.labels.manageReviewersList.emptyState}</div>;
   const glyph = (reviewers.length > 1) ?
      <Glyphs.Edit16x16/>
      : <Glyphs.Add16x16/>;

   return (
      <div className="flex-container">
         {leftElement}
         {isOwner && review.ReviewVersions.filter(ver => !ver.IsDeleted).pop().VersionNumber === reviewVersion.VersionNumber &&
            <ControlButton
               title={Strings.labels.addReviewersButtonTitle}
               buttonType={TscButtonType.tertiary}
               themeName={themeName}
               glyph={glyph}
               onClick={() => setModalState(ModalStates.manageReviewers)}
               testId="details-pane-manage-reviewers-button"/>
         }
      </div>
   );
};

export interface ReviewersDetailElementProps extends Themeable {
   review: ReviewModel;
   reviewVersion: ReviewVersionModel;
   isOwner: boolean;
   setModalState(modalState: ModalStates): void;
}
